import React, {useEffect,useContext,useState} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {input} from "../../utils/linker";
import {ComponentContext} from "../../contexts";
import reactionCombiner from "../../utils/reactionCombiner";

function String(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);
  let _ref=null;
  const [comb,setComb]=useState(new reactionCombiner());

  useEffect(() => {
    // mount
    comb.addReaction(()=>{
      return compStore.data[props.index]?compStore.data[props.index].focus:0;
    },(focus)=>{
      setTimeout(()=>{
        if(focus && _ref) {
          _ref.focus();
          runInAction(()=>{
            compStore.data[props.index].focus=0;
          });
        }
      },0);
    },{ fireImmediately:true });

    return () => {
      // unmount
      comb.clear();
    }
  }, []);

  const newRef=(ref)=>{
    _ref=ref;
  }

  const getTitleField=()=>{
    if(props.fieldSettings && props.fieldSettings.title_field) {
      return props.fieldSettings.title_field;
    }
    return "value";
  };


  return (
    <div>
      <input ref={(ref)=>{ newRef(ref); }} placeholder={compStore.options.placeholder} type="text" className="w100" {...input(compStore.data[props.index], getTitleField())} />
    </div>
  )
};

String.defaultProps = {};

String.propTypes = {
  index:PropTypes.number,
}

export default observer(String);
